// @flow
import { combineReducers } from 'redux';
import appointments from 'reducers/appointments';
import auth from 'reducers/auth';
import logs from 'reducers/logs';
import reports from 'reducers/reports';
import surveys from 'reducers/surveys';
import topics from 'reducers/topics';
import users from 'reducers/users';
import employees from 'reducers/employees';
import assignments from 'reducers/assignments';

export default combineReducers({
  appointments,
  auth,
  logs,
  reports,
  surveys,
  topics,
  users,
  employees,
  assignments,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js